import { isDevelopmentEnvironment } from "@/lib/env";

// Desligado: a funcionalidade aparece em todos os ambientes. Ligue (true) para restringir a fora de produção
// (localhost e homologação/DEV), usando a mesma verificação de ambiente do resto do sistema (@/lib/env).
export const INTEGRATED_ORDERS_DEV_ONLY = false;

export let isIntegratedOrdersEnabled = false;

// Tela "Pedidos integrados" (Administrativo): listagem, exportação, edição de registros em revisão e reintegração
// dos itens de purchase_orders_b2b_request (pré-pedidos do ERP). Comente a linha abaixo para desativar no frontend.
// Mantenha em sincronia com Features/IntegratedOrdersFeature.cs do backend.
isIntegratedOrdersEnabled = !INTEGRATED_ORDERS_DEV_ONLY || isDevelopmentEnvironment;
